import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { useTimers } from '../store/timers'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useTimesheets } from '../store/timesheets'
import { isSameDay } from 'date-fns'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'BannerProcessing',
  setup(__props) {

const { t } = useI18n({ useScope: 'global' })

const { isLocked } = storeToRefs(useTimers())
const { timesheets } = storeToRefs(useTimesheets())
const getTimesheetIndexByDate = (date: Date) => {
  return timesheets.value.findIndex((ts) => isSameDay(new Date(ts.date), date))
}
const thisTimecard = computed(() => {
  const index = getTimesheetIndexByDate(new Date())
  if (index == -1) return false
  else {
    return timesheets.value[index]
  }
})
const timecardColor = computed(() => {
  if (thisTimecard.value) {
    switch (thisTimecard.value.status) {
      case 'approved':
        return 'bg-positive'
      default:
        return 'bg-grey'
    }
  } else return 'bg-grey'
})

const showBanner = computed(() => {
  if (isLocked.value) {
    // if (thisTimecard.value && thisTimecard.value.status != 'declined') {
    return true
  } else {
    return false
  }
})

return (_ctx: any,_cache: any) => {
  const _component_q_banner = _resolveComponent("q-banner")!

  return (showBanner.value)
    ? (_openBlock(), _createBlock(_component_q_banner, {
        key: 0,
        class: _normalizeClass(["text-white q-mb-md", timecardColor.value])
      }, {
        default: _withCtx(() => [
          (thisTimecard.value && thisTimecard.value.status == 'approved')
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(t)('timecard.approved')), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(t)('timecard.processing')), 1))
        ]),
        _: 1
      }, 8, ["class"]))
    : _createCommentVNode("", true)
}
}

})